@let v = value();

@switch (v.type) {
  @case ('GROUP') {
    <div
      class="text-text-primary mx-1 inline-block h-full rounded-md border-3 border-purple-300 bg-purple-50 p-4 text-3xl font-bold select-none"
    >
      {{ v.value }}
    </div>
  }
  @case ('KLANK') {
    @if (v.value === '(a)a' || v.value === '(e)e' || v.value === '(o)o' || v.value === '(u)u') {
      <rid-compressable-klank-card class="font-bold text-purple-500" [content]="v.value.at(-1)!" />
    } @else if (v.value === 'sjwa' || v.value === 'ig' || v.value === 'lijk') {
      <rid-compressable-klank-card class="text-purple-500 italic" [content]="v.value === 'sjwa' ? 'e' : v.value" />
    } @else {
      <rid-compressable-klank-card [content]="v.value" />
    }
  }
  @case ('SPACE') {
    <rid-compressable-klank-card class="opacity-50" content="⎵" />
  }
  @case ('KLANKVOET') {
    <div class="border-surface-300 ease-out-back mx-1 inline-block h-full content-center rounded-md border-3 bg-white p-4 transition-all">
      @switch (v.value) {
        @case ('>') {
          <i-klankvoet-normal class="size-[1.5lh] text-emerald-500" />
        }
        @case ('<') {
          <i-klankvoet-stom class="size-[1.5lh] text-rose-500" />
        }
      }
    </div>
  }
  @case ('RULE') {
    <div
      class="font-family-din mx-1 inline-block h-full rounded-md border-3 border-dashed bg-purple-100/50 p-4 text-3xl font-bold text-purple-500 select-none"
    >
      {{ v.value === '+■' ? '■' : v.value }}
    </div>
  }
}
